import { useState } from 'react';
import api from '../api';
import stili from './competenze/stili';
import { validaPassword, regolaPassword } from '../utils/regolaPassword';

// "Imposta password" di un account cliente esistente: la sceglie l'operatore (es. concordata al telefono). Stesse regole della creazione
// dell'account. La password viaggia solo nella richiesta e non resta in nessun altro punto. La casella decide se il cliente deve cambiarla
// al primo accesso (predefinito sì: così le sessioni aperte si chiudono); senza il cambio, le sessioni aperte restano.
export default function ImpostaPasswordCliente({ aziendaId, email, etichetta, onChiudi, onSalvato }) {
  const [password, setPassword] = useState('');
  const [richiediCambio, setRichiediCambio] = useState(true);
  const [errore, setErrore] = useState('');
  const [invio, setInvio] = useState(false);

  const salva = async (e) => {
    e.preventDefault();
    const problema = validaPassword(password, email, 'cliente');
    if (problema) { setErrore(problema); return; }
    setErrore('');
    setInvio(true);
    try {
      await api.put(`/aziende/${aziendaId}/password`, { password, richiedi_cambio: richiediCambio });
      onSalvato();
    } catch (err) {
      setErrore(err.response?.data?.errore || 'Impostazione della password non riuscita');
      setInvio(false);
    }
  };

  return (
    <div style={stili.overlay} role="dialog" aria-label="Imposta password dell'account cliente">
      <form style={{ ...stili.modal, maxWidth: '460px' }} onSubmit={salva}>
        <h3 style={{ marginTop: 0 }}>Imposta password</h3>
        {etichetta && <p style={{ margin: '0 0 0.8rem', color: '#555', fontSize: '0.9rem' }}>{etichetta}</p>}
        {errore && <div role="alert" style={stili.errore}>{errore}</div>}
        <div style={stili.campo}>
          <label style={stili.label} htmlFor="imposta-pw">Nuova password</label>
          <input id="imposta-pw" type="text" autoComplete="off" value={password} onChange={e => setPassword(e.target.value)} style={stili.input} />
          <div style={{ fontSize: '0.78rem', color: '#777', marginTop: '0.25rem' }}>{regolaPassword('cliente')}</div>
        </div>
        <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', fontSize: '0.88rem', margin: '0.2rem 0 0.8rem' }}>
          <input type="checkbox" checked={richiediCambio} onChange={e => setRichiediCambio(e.target.checked)} />
          Il cliente deve cambiarla al primo accesso
        </label>
        <div style={{ background: '#fff8e1', color: '#7a5b00', padding: '0.6rem', borderRadius: '6px', fontSize: '0.85rem' }}>
          La password attuale smette di funzionare.{' '}
          {richiediCambio
            ? 'Le sessioni aperte vengono chiuse e il cliente dovrà sceglierne una nuova al primo accesso.'
            : 'Il cliente non dovrà cambiarla e le sessioni già aperte restano attive.'}
          {' '}L'operazione è registrata, senza la password.
        </div>
        <div style={stili.azioni}>
          <button type="button" onClick={onChiudi} style={stili.btnSecondary}>Annulla</button>
          <button type="submit" disabled={invio} style={stili.btn}>Salva password</button>
        </div>
      </form>
    </div>
  );
}
